export default __webpack_public_path__ + "static/media/square-gas-pump.4c4b4bae.svg";